import { gql } from '@apollo/client';
import { LocationEmailFragment } from 'graphql/LocationEmail/fragments/LocationEmailFragment';
import { LocationPhoneFragment } from 'graphql/LocationPhone/fragments/LocationPhoneFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { TagFragment } from 'graphql/Tag/fragments/TagFragment';
/**
 * @fragment ClientTableLocationFragment
 * @since 1.0.0
 */
export const ClientTableLocationFragment = gql `
  fragment ClientTableLocationFragment on Location {
    id
    city

    primaryEmail {
      ...LocationEmailFragment
    }

    primaryPhone {
      ...LocationPhoneFragment
    }
  }

  ${LocationEmailFragment}
  ${LocationPhoneFragment}
`;
/**
 * @fragment ClientListFragment
 * @since 1.0.0
 */
export const ClientListFragment = gql `
  fragment ClientListFragment on Client {
    id
    name
    number
    isEndClient
    website
    language {
      code
    }
    discount
    status
    createdAt
    updatedAt

    primaryLocation {
      ...ClientTableLocationFragment
    }

    image {
      ...MediaFragment
    }

    tags {
      ...TagFragment
    }
  }

  ${ClientTableLocationFragment}
  ${MediaFragment}
  ${TagFragment}
`;
